
export default {
    name: 'CartSummary',

    props: {
        summary: {
            type: Object,
            required: true,
            validator: (obj) => {
                return obj.subtotal && obj.total;
            }
        }
    },

    data() {
        return {
            showTooltip: false
        };
    },

    computed: {
        computedDiscounts() {
            const discountItems = [];
            let totalDiscount = 0;

            for (const [key, value] of Object.entries(this.summary)) {
                if (key.includes('discount') && value.value) {
                    discountItems.push({
                        title: value.title || key,
                        value: value.value
                    });
                    totalDiscount += value.value;
                }
            }

            return {
                items: discountItems,
                totalDiscount
            };
        }
    },

    methods: {
        formatCurrency(value) {
            return `$${value.toFixed(2)}`;
        }
    }
};
